import { render, staticRenderFns } from "./ChartsConfigModal.vue?vue&type=template&id=6ef5f6c2&"
import script from "./ChartsConfigModal.vue?vue&type=script&lang=js&"
export * from "./ChartsConfigModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports